import levenshtein from "fast-levenshtein";

export const SEARCH_PAGE_REGEX = /^\/universities\/([0-9]+)\/search/;

export const LARGE_DEVICE_MIN_WIDTH = 992; // As set by Bootstrap; cutoff for desktop.

export const jsonOrThrowError = function(res) {
	if (res.status === 200) {
		return res.json();
	} else {
		throw new Error(res.status);
	}
};

const WHITELIST = {
	punto: true,
	computadora: true
};
const BAD_WORD_REGEXES = {
	bellako: /b+e+l+l+a+k+o+/,
	cabron: /c+a+b+r+o+n+/,
	cbrn: /c+b+r+n+/,
	kabron: /k+a+b+r+o+n+/,
	kbrn: /k+b+r+n+/,
	puto: /p+u+t+o+/,
	violo: /v+i+o+l+o+/,
	violar: /v+i+o+l+a+r+/,
	pendejo: /p+e+n+d+e+j+o+/,
	mamon: /m+a+m+o+n+/,
	chocha: /c+h+o+c+h+a+/,
	crika: /c+r+i+k+a/,
	chicha: /c+h+i+c+h+a+/,
	huelebicha: /h+u+e+l+e+b+i+c+h+a+/,
	bicho: /b+i+c+h+o+/,
	mamao: /m+a+m+a+o+/,
	pinga: /p+i+n+g+a+/,
	pingo: /p+i+n+g+o+/,
	chinga: /c+h+i+n+g+a+/,
	maricon: /m+a+r+i+c+o+n+/,
	culo: /c+u+l+o+/
};

const COMMON_SUBS = {
	"0": "o"
};

/**
 * Detect BAD WORDS in text.
 * 1. Lowercase.
 * 2. cabr0n, cabrón, cabron (sub letters)
 * 3. cbrn (missing letters)
 * 4. cabronnnnnnn
 * 5. cabroncito
 * 6. c a br on c i t o
 * 1. normalize (lowercase + subletters + collapse repetitions) + merge all together.
 * 2. check if (c+a+b+r+o+n+) matches
 * 3. check if leivenstein distance < 2
 */
export function hasBadWord(text) {
	let normalized = text.toLowerCase().trim();
	normalized = normalized.replace(/[^\w\s]/gi, ""); // remove special characters.
	for (const char in COMMON_SUBS) {
		normalized = normalized.replace(char, COMMON_SUBS[char]);
	}

	const tokens = normalized.split(" ");
	const merged = tokens.join("");
	tokens.push(merged); // also check merging everything, to avoid c a b r o n attempts.

	// If any token contains a bad word, fail.
	// Contains bad word == matches collapsed regex, leveinstein distance < 2
	return tokens.some(token => {
		if (token in WHITELIST) {
			return false;
		}

		for (const badWord in BAD_WORD_REGEXES) {
			const badWordRegex = BAD_WORD_REGEXES[badWord];
			const distance = levenshtein.get(badWord, token);
			if (badWordRegex.test(token) || distance <= 1) {
				return true;
			}
		}
		return false;
	});
}



// WEBPACK FOOTER //
// ./src/util.js